// extracted by mini-css-extract-plugin
export default {"wrapper":"CreditFormList_wrapper__izfY5"};